import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/home.vue';
import { getBlogPost } from '@/content/blogs';

Vue.use(VueRouter);

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
	return originalPush.call(this, location).catch((err) => err);
};

const originalResolve = VueRouter.prototype.resolve;
VueRouter.prototype.resolve = function resolve(to, current, append) {
	const resolved = originalResolve.call(this, to, current, append);
	if (resolved.href) {
		resolved.href = withTrailingSlash(resolved.href);
	}
	if (resolved.location && resolved.location.path && resolved.location.path !== '/' && !resolved.location.path.endsWith('/')) {
		resolved.location.path = `${resolved.location.path}/`;
	}
	return resolved;
};

function withTrailingSlash(href) {
	if (!href || href.startsWith('#') || href.startsWith('mailto:') || href.startsWith('http')) {
		return href;
	}
	const hashIndex = href.indexOf('#');
	const hash = hashIndex >= 0 ? href.slice(hashIndex) : '';
	const withoutHash = hashIndex >= 0 ? href.slice(0, hashIndex) : href;
	const queryIndex = withoutHash.indexOf('?');
	const query = queryIndex >= 0 ? withoutHash.slice(queryIndex) : '';
	const path = queryIndex >= 0 ? withoutHash.slice(0, queryIndex) : withoutHash;
	if (!path || path === '/') {
		return href;
	}
	const slashed = path.endsWith('/') ? path : `${path}/`;
	return `${slashed}${query}${hash}`;
}

const canonical = (path) => [
	{
		rel: 'canonical',
		href: `https://androidwaves.org${path}`,
	},
];

const appName = 'AndroidWaves';

export const constRoutesPc = [
	{
		path: '/',
		redirect: '/gb-whatsapp-apk/',
	},
	{
		path: '/gb-whatsapp-apk/',
		name: 'gb-whatsapp-apk',
		meta: {
			appname: appName,
			locale: 'en',
			title: 'GB WhatsApp APK Download v18.80 – Latest Version Aug 2026',
			keywords: 'GB WhatsApp, GB WhatsApp APK download',
			description: 'Download GB WhatsApp v18.80 APK, the latest version updated in August 2026. Get the newest features, privacy options, and installation guide.',
			link: canonical('/gb-whatsapp-apk/'),
		},
		component: Home,
	},
	{
		path: '/gb-whatsapp-old-versions/',
		name: 'old-versions',
		meta: {
			appname: appName,
			locale: 'en',
			title: 'GB WhatsApp Old Versions Download – Previous APK Releases (2015-2026)',
			keywords: 'GB WhatsApp old versions, GBWhatsApp APK archive',
			description: 'Download old GB WhatsApp APK versions, including previous releases from 2025, 2024, 2023 and earlier. Find older versions and Android requirements.',
			link: canonical('/gb-whatsapp-old-versions/'),
		},
		component: () => import('@/views/oldVersions.vue'),
	},
	{
		path: '/blogs/',
		name: 'blogs',
		meta: {
			appname: appName,
			locale: 'en',
			title: 'WhatsApp Mods Blog – GB WhatsApp Guides & Updates',
			keywords: 'GB WhatsApp blogs, WhatsApp mod tips',
			description: 'Read GB WhatsApp guides, WhatsApp mod tips, feature updates, troubleshooting solutions, and useful how-to articles for WA apps.',
			link: canonical('/blogs/'),
		},
		component: () => import('@/views/blogs.vue'),
	},
	{
		path: '/blogs/:slug/',
		name: 'blog-post',
		meta: {
			appname: appName,
			locale: 'en',
			isBlogPost: true,
		},
		component: () => import('@/views/blogPost.vue'),
		beforeEnter(to, from, next) {
			const post = getBlogPost(to.params.slug);
			if (!post) {
				return next({ path: '/blogs/', replace: true });
			}
			to.meta.title = post.metaTitle || post.title;
			to.meta.description = post.description;
			to.meta.keywords = post.title;
			to.meta.link = canonical(`/blogs/${post.slug}/`);
			next();
		},
	},
	{
		path: '/whatsapp-mods/',
		name: 'whatsapp-mods',
		meta: {
			appname: appName,
			locale: 'en',
			title: 'WhatsApp Mods – Best WA Apps & Alternatives',
			keywords: 'WhatsApp Mods, GB WhatsApp, FM WhatsApp, YOWhatsApp',
			description: 'Explore popular WhatsApp mods and WA apps, including GB WhatsApp, FM WhatsApp, YOWhatsApp, WhatsApp Plus, MB WhatsApp, and more.',
			link: canonical('/whatsapp-mods/'),
		},
		component: () => import('@/views/mods.vue'),
	},
	{
		path: '/fm-whatsapp-apk/',
		name: 'fm-whatsapp-apk',
		meta: {
			appname: appName,
			locale: 'en',
			title: 'Download FM WhatsApp V10.10 for Android | 2026',
			keywords: 'FM WhatsApp, FMWhatsApp APK',
			description: 'FM WhatsApp is a modified version that offers extra features and customization options. Download FM WhatsApp on your phone to enjoy more customized features.',
			link: canonical('/fm-whatsapp-apk/'),
		},
		component: () => import('@/views/fmWhatsapp.vue'),
	},
	{
		path: '/yo-whatsapp-apk/',
		name: 'yo-whatsapp-apk',
		meta: {
			appname: appName,
			locale: 'en',
			title: 'YO WhatsApp APK Download V10.10 Updated 2026',
			keywords: 'YO WhatsApp, YoWhatsApp APK',
			description: 'Download YoWhatsApp APK v10.10 for Android with extra privacy controls, custom themes, Anti-Delete Messages, Status tools, and more.',
			link: canonical('/yo-whatsapp-apk/'),
		},
		component: () => import('@/views/yoWhatsapp.vue'),
	},
	{
		path: '/blue-whatsapp-apk/',
		name: 'blue-whatsapp-apk',
		meta: {
			appname: appName,
			locale: 'en',
			title: 'Blue WhatsApp APK Download v18.80 for Android 2026',
			keywords: 'Blue WhatsApp, Blue WhatsApp APK',
			description: 'Download Blue WhatsApp APK for Android and enjoy custom themes, privacy controls, Status Downloader, Anti-Delete Messages, and more.',
			link: canonical('/blue-whatsapp-apk/'),
		},
		component: () => import('@/views/blueWhatsapp.vue'),
	},
	{
		path: '/wa-gb-id/',
		name: 'wa-gb-id',
		meta: {
			appname: appName,
			locale: 'id',
			title: 'WA GB APK Unduh – WhatsApp GB Versi Terbaru 2026',
			keywords: 'WA GB, WhatsApp GB, unduh WA GB APK',
			description: 'Unduh WA GB APK versi terbaru 2026 dengan fitur privasi, tema, anti-delete, auto-reply, dan berbagai pilihan kustomisasi WhatsApp.',
			link: canonical('/wa-gb-id/'),
		},
		component: () => import('@/views/idHome.vue'),
	},
	{
		path: '/download/',
		redirect: '/gb-whatsapp-apk/',
	},
	{
		path: '/about-us/',
		name: 'about-us',
		meta: {
			appname: appName,
			pageKey: 'about',
			title: 'About Us – AndroidWaves',
			description: 'Learn more about AndroidWaves, our Android app guides, reviews, tutorials, and the team behind the website.',
			keywords: 'About AndroidWaves, Android app guides',
			link: canonical('/about-us/'),
		},
		component: () => import('@/views/legalPage.vue'),
	},
	{
		path: '/contact/',
		name: 'contact',
		meta: {
			appname: appName,
			pageKey: 'contact',
			title: 'Contact Us – AndroidWaves',
			description: 'Contact AndroidWaves for questions, content corrections, broken links, copyright concerns, privacy questions, or website feedback.',
			keywords: 'Contact AndroidWaves, AndroidWaves email',
			link: canonical('/contact/'),
		},
		component: () => import('@/views/legalPage.vue'),
	},
	{
		path: '/privacy-policy/',
		name: 'privacy-policy',
		meta: {
			appname: appName,
			pageKey: 'privacy',
			title: 'Privacy Policy – AndroidWaves',
			description: 'Read the AndroidWaves Privacy Policy to learn how we collect, use, protect, and manage information when you use our website.',
			keywords: 'AndroidWaves privacy policy',
			link: canonical('/privacy-policy/'),
		},
		component: () => import('@/views/legalPage.vue'),
	},
	{
		path: '/privacy/',
		redirect: '/privacy-policy/',
	},
	{
		path: '/terms-and-conditions/',
		name: 'terms-and-conditions',
		meta: {
			appname: appName,
			pageKey: 'terms',
			title: 'Terms & Conditions – AndroidWaves',
			description: 'Read the AndroidWaves Terms & Conditions covering website use, content, third-party apps, external links, and user responsibilities.',
			keywords: 'AndroidWaves terms and conditions',
			link: canonical('/terms-and-conditions/'),
		},
		component: () => import('@/views/legalPage.vue'),
	},
	{
		path: '/disclaimer/',
		name: 'disclaimer',
		meta: {
			appname: appName,
			pageKey: 'disclaimer',
			title: 'Disclaimer – AndroidWaves',
			description: 'Read the AndroidWaves Disclaimer about third-party apps, APK files, external links, content accuracy, compatibility, and website use.',
			keywords: 'AndroidWaves disclaimer',
			link: canonical('/disclaimer/'),
		},
		component: () => import('@/views/legalPage.vue'),
	},
	{
		path: '/dmca/',
		name: 'dmca',
		meta: {
			appname: appName,
			pageKey: 'dmca',
			title: 'DMCA Policy – AndroidWaves',
			description: 'Learn how to submit a DMCA copyright complaint to AndroidWaves and report potentially infringing content on the website.',
			keywords: 'AndroidWaves DMCA',
			link: canonical('/dmca/'),
		},
		component: () => import('@/views/legalPage.vue'),
	},
	{
		path: '/cookie-policy/',
		name: 'cookie-policy',
		meta: {
			appname: appName,
			pageKey: 'cookies',
			title: 'Cookie Policy – AndroidWaves',
			description: 'Learn how AndroidWaves uses cookies for website functionality, analytics, preferences, advertising, and overall site performance.',
			keywords: 'AndroidWaves cookie policy',
			link: canonical('/cookie-policy/'),
		},
		component: () => import('@/views/legalPage.vue'),
	},
];

const routes = constRoutesPc;

export default function createRouter() {
	const router = new VueRouter({
		mode: 'history',
		routes,
		scrollBehavior(to, from, savedPosition) {
			if (savedPosition) {
				return savedPosition;
			}
			if (to.hash) {
				return { selector: to.hash };
			}
			return { x: 0, y: 0 };
		},
	});
	router.beforeEach((to, from, next) => {
		if (to.path !== '/' && !to.path.endsWith('/')) {
			return next({
				path: `${to.path}/`,
				query: to.query,
				hash: to.hash,
				replace: true,
			});
		}
		next();
	});
	return router;
}
